import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube, Twitter, Mail, MapPin, Heart } from "lucide-react";
import Logo from "./Logo";
import { EMAIL, ADDRESS, WHATSAPP_LINK } from "../data/content";

const cols = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Blog", to: "/blog" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-200 bg-white">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo testId="footer-logo" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-600">
              Convert your manual registers to digital in seconds. Photograph your register — we digitize it instantly.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Instagram, href: "https://instagram.com", label: "instagram" },
                { Icon: Linkedin, href: "https://linkedin.com", label: "linkedin" },
                { Icon: Youtube, href: "https://youtube.com", label: "youtube" },
                { Icon: Twitter, href: "https://twitter.com", label: "twitter" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-social-${label}`}
                  aria-label={label}
                  className="grid h-9 w-9 place-items-center rounded-full border border-zinc-200 text-zinc-700 transition-colors hover:bg-zinc-950 hover:text-white hover:border-zinc-950"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500">{col.title}</div>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                      to={l.to}
                      className="text-sm text-zinc-700 hover:text-zinc-950"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500">Contact</div>
            <ul className="mt-4 space-y-3 text-sm text-zinc-700">
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 text-zinc-500" />
                <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="hover:text-zinc-950">{EMAIL}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 text-zinc-500" />
                <span>{ADDRESS}</span>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-zinc-950 px-4 py-2 text-xs font-medium text-white hover:bg-zinc-800"
                >
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-zinc-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-zinc-500">
            © 2026 Register to Digital. Made in India <span aria-label="India" role="img">🇮🇳</span>
          </p>
          <p className="inline-flex items-center gap-1 text-xs text-zinc-500">
            Designed with <Heart className="h-3.5 w-3.5 text-zinc-900" strokeWidth={2.5} /> in Meerut
          </p>
        </div>
      </div>
    </footer>
  );
}
